import { useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { ClientDetails } from "src/interfaces/IClient";
import { Device } from "src/interfaces/IDevice";
import { Zone } from "src/interfaces/IZone";
import { queryGetDevices } from "src/services/graphql/Device";
import _get from "lodash/get";
import { GqlTableQueryResult } from "./types";

// eslint-disable-next-line import/prefer-default-export
export function useDeviceQuery(
  client: ClientDetails,
  zones: Array<Zone>
): GqlTableQueryResult<Device> {
  const [devices, setDevices] = useState<Array<Device>>([]);

  const {
    loading: isLoading,
    refetch,
    data,
  } = useQuery(queryGetDevices(client.client_dbname), {
    variables: {
      zone_id: {
        _in: zones.map((z) => z.zone_id),
      },
    },
    skip: zones.length <= 0,
  });

  useEffect(() => {
    setDevices(_get(data, `${client.client_dbname}_device`, []));
  }, [data, setDevices, client]);

  return { data: devices, isLoading, refetch };
}
